import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { ChangeEvent, useEffect, useState } from 'react';
import Loader from '../../_components/molecules/Loader';
import {
  BasicTable,
  CardComponent,
  Columns,
  PageTitleAndSubTitle,
  VerticalBar,
  cellStyles4,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import highCostClaimantsMessages from '../../core-utils/messages/highCostClaimantsMessages';
import { pageScrollDown } from '../SummaryPage';
import ReportsModal from '../../_components/organisms/ReportsModal';
import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import TabSelection from '../../_components/molecules/TabSelection';
import { useStores } from '../../stores';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import properties from '../../core-utils/properties';
import axios from 'axios';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import Line from '../../../public/Images/Line 132.png';
import { formatClaimantsDistData } from '../../core-utils/helper-utils/highCostClaimantsHelper';
import { HIGH_COST_CLAIMS, PATIENT_DETAILS } from '../../core-utils/routes';
import { useNavigate } from 'react-router-dom';

import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import moment from 'moment';
import CustomColumnsTable from '../../_components/organisms/CustomColumnsTable';
import {
  columnsDropdownOptions,
  defaultColumns,
  formatMembersListData,
  getColumns,
} from '../../core-utils/helper-utils/customColumnsHelper';
import {
  downloadPdf,
  handleDownloadCSV,
} from '../../core-utils/helper-utils/downloadPdfHelper';
import { getInfoIcon } from '../../core-utils/helper-utils/infoIconHelper';
import DateFilter from '../../_components/molecules/DateFilter';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import componentConstants from '../../core-utils/messages/componentConstants';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { getClaimCohortMembersCount } from '../../core-utils/axios/Cohort/Summary';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import { observer } from 'mobx-react';

export interface HighCostClaimantsProps {}

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '1236px',
    padding: '40px 0px 66px 63px',
  },
  container: {
    marginBottom: '36px',

    position: 'relative',
  },
  titleContainer: {
    position: 'absolute',
    top: '-1px',
    left: '184px',
    display: 'flex',
    alignItems: 'center',
  },
  cardRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  claimDistributionContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '170px',
    padding: '2rem',
  },
  line: {
    position: 'absolute',
    left: '10%',
  },
});

const HighCostClaimantsPage: React.FC<HighCostClaimantsProps> = observer(
  ({}) => {
    const { classes } = useStyles();

    //Constants
    const messages = highCostClaimantsMessages.HIGH_COST_CLAIMANTS_PAGE;
    const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;
    const navigate = useNavigate();
    const pageSize = 10;
    const defaultSelectedColumns = defaultColumns;
    const [loader] = useState<any>(<Loader />);
    const claimDistributionColumns: Columns[] = [
      {
        name: 'CATEGORY',
        align: 'left',
        width: '',
        cellStyles: cellStyles4,
      },
      {
        name: 'COST RANGE',
        align: 'left',
        width: '',
        cellStyles: cellStyles4,
      },
      {
        name: 'MEMBERS',
        align: 'left',
        width: '',
        cellStyles: cellStyles4,
      },
      {
        name: 'TOTAL COST',
        align: 'right',
        width: '',
        cellStyles: cellStyles4,
      },
      {
        name: 'PLAN PAID',
        align: 'right',
        width: '',
        cellStyles: cellStyles4,
      },
      {
        name: 'MEMBER PAID',
        align: 'right',
        width: '',
        cellStyles: cellStyles4,
      },
    ];
    const infoIcon = getInfoIcon(
      `Top 3 Diagnosis based on Total Cost.`,
      () => {},
      {
        display: 'flex',
        alignItems: 'center',
      },
    );

    //Stores

    const {
      employerGroupStore,
      recommendedTabStore,
      memberSummaryStore,
      quaterlyReportStore,
      cohortDetailsStore,
      loginPageStore,
    } = useStores();

    const {
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      isIncurredDate,
      isPaidDate,
      isPlanDatesFetched,
      aggregationParameter,
    } = quaterlyReportStore;

    const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
    const payload = useAPIPayload();
    const { open, openModal, closeModal, isEditMode } = useCohortModal();

    const {
      totalResults,
      memberIds: memberIdList,
      isInitializing,
    } = useCohortOnPageLoad({
      fetchTotalResults: () =>
        getClaimCohortMembersCount(
          employerGroupStore.employerGroupResponseData.eg_nid,
          incurredStartDate,
          incurredEndDate,
          paidStartDate,
          paidEndDate,
          aggregationParameter,
        ),
      enabled:
        isPlanDatesFetched &&
        !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
    });

    //State Variables
    const [loading, setLoading] = useState<boolean>(false);
    const [openReportsModal, setOpenReportsModal] = useState(false);
    const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
    const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
      false,
    );
    const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
      false,
    );
    const [claimantsDistData, setClaimantsDistData] = useState<any>([]);
    const [clickedMember, setClickedMember] = useState<string>();
    const [riskMemberListData, setRiskMemberListData] = useState<any[]>([]);
    const [memberIds, setMemberIds] = useState<string[]>([]);
    const [selectedColumns, setSelectedColumns] = useState<string[]>(
      defaultSelectedColumns,
    );
    const [tableColumns, setTableColumns] = useState<Columns[]>(
      getColumns(defaultSelectedColumns, infoIcon),
    );
    const [columnsDropdownOption, setColumnsDropdownOption] = useState<any[]>(
      columnsDropdownOptions,
    );
    const [tableLoading, setTableLoading] = useState<boolean>(false);
    const [sortField, setSortField] = useState<string>('totalCost');
    const [sortOrder, setSortOrder] = useState<number>(-1);
    const [totalPages, setTotalPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const screenName = allScreenLabel;
    const [aiLoading, setAiLoading] = useState<boolean>(false);
    const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
    const [aiSummaryData, setAiSummaryData] = useState<
      { title: string; description: string }[]
    >([]);
    const [snackbarState, setSnackbarState] = React.useState<{
      open: boolean;
      message: string;
      severity: MuiColor | undefined;
      duration: null | number;
    }>({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
    const abortController = new AbortController();

    //Functions
    const handleSelectedIndex = (index: number) => {
      setSelectedTabIndex(index);
      if (!recommendationFetched) {
        getRecommendationsData(
          employerGroupStore?.employerGroupResponseData?.eg_nid,
          messages.TITLE,
          recommendedTabStore,
          setRecommendationLoading,
        );
        setRecommendationFetched(true);
      }
    };

    const handleOpenSnackBar = (
      message: string,
      severity: MuiColor,
      duration: number | null,
    ) => {
      setSnackbarState({
        open: true,
        message: message,
        severity: severity,
        duration: duration,
      });
    };

    const handleCloseSnackBar = (
      event?: React.SyntheticEvent,
      reason?: string,
    ) => {
      if (reason === 'clickaway') {
        return;
      }
      setSnackbarState({
        open: false,
        message: '',
        severity: undefined,
        duration: null,
      });
    };

    const handleAskAi = () => {
      setActiveAskAi(true);
      getAiSummarizedData();
    };

    //Custom Member Table Functions
    const handleChangeColumns = () => {
      setTableColumns(getColumns(selectedColumns, infoIcon));
      memberIds.length > 0
        ? getRiskMembersList(memberIds)
        : setRiskMemberListData([]);
    };

    const handleExportCSV = () => {
      handleDownloadCSV(
        properties.aiqBaseUrl + properties.membersList + '/csv',
        { ...membersListRequestBody, member_unique_id_list: memberIds ?? [] },
        `TopHighCostClaimants.csv`,
        handleOpenSnackBar,
      );
    };

    const handleMemberClick = (value: string) => {
      setClickedMember(value);
    };

    const handleSort = (event: any, column: any, item: any) => {
      const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
      const { sortColumnName } = column;
      if (!sortColumnName) {
        return;
      }

      setSortField(sortColumnName);
      setSortOrder(sortOrder);
    };

    const handlePageChange = (event: ChangeEvent<unknown>, page: number) => {
      setPageNumber(page);
    };

    //Api Calls
    const membersListRequestBody = {
      eg_nid: employerGroupStore.employerGroupResponseData.eg_nid,
      startYear: moment(
        aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
        'YYYY-MM-DD',
      ).year(),
      pageNumber: pageNumber - 1,
      pageSize: pageSize,
      sortField: sortField,
      sortOrder: sortOrder,
      category: 'chronic',
      startDate:
        aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
      endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
      max_claim_date:
        employerGroupStore.employerGroupResponseData.max_claim_date,
      columnList: selectedColumns,
      diagnosis_count: 3,
      diagnosis_sort_field: 'totalPaid',
    };

    const getClaimDistributionData = async () => {
      const baseUrl =
        properties.aiqBaseUrl +
        properties.summaryBaseUrl +
        properties.claimantsDistribution;

      return await axios
        .post(
          baseUrl,
          {
            ...payload,
            member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
          },
          { signal: abortController.signal },
        )
        .then(async (res) => {
          if (res) {
            const response = res?.data?.data;
            setClaimantsDistData(formatClaimantsDistData(response));

            const memberIDs = response[0]?.members.map(
              (item: any) => item?.member_unique_id,
            );
            setMemberIds(memberIDs);
            setTotalPages(Math.ceil(memberIDs?.length / pageSize));
            await getRiskMembersList(memberIDs);
          }
        })
        .catch((err) => {
          return err;
        });
    };

    const getMemberClaims = async (memberId: string) => {
      return await axios
        .post(
          properties.aiqBaseUrl +
            properties.membersBaseUrl +
            properties.memberDetails,
          {
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
            paidStartDate,
            paidEndDate,
            incurredStartDate,
            incurredEndDate,
            aggregationParameter,
            member_unique_id: [memberId],
            claim_id_list: [],
          },
        )
        .then((response) => response.data);
    };

    const getRiskMembersList = async (memberIds: string[]) => {
      setTableLoading(true);

      const response = await axios.post(
        properties.aiqBaseUrl + properties.membersList,
        { ...membersListRequestBody, member_unique_id_list: memberIds ?? [] },
      );

      if (response?.status === 200) {
        const updatedData = await Promise.all(
          response?.data?.data?.memberList?.map(async (item: any) => {
            const memberClaimsData = await getMemberClaims(item['Member ID']);
            return {
              ...item,
              claimData: memberClaimsData?.data,
            };
          }),
        );
        let columns: any[] = selectedColumns;
        if (!response.data.data.isPreviousYearAvailable) {
          columns = columns.filter(
            (column) => column !== 'Previous Year Cost (Medical + Rx)',
          );
          const dropDownOption = columnsDropdownOption.filter(
            (column) => !column.includes('Previous Year'),
          );
          setColumnsDropdownOption(dropDownOption);
          setSelectedColumns(columns);
          setTableColumns(getColumns(columns, infoIcon));
        }
        setRiskMemberListData(formatMembersListData(updatedData, columns));
        setTableLoading(false);
      }
    };
    const getAiSummarizedData = async () => {
      try {
        setAiLoading(true);

        const cleanData = {
          title_1: claimantsDistData, // distribution buckets

          title_2: riskMemberListData, // already contains meaningful member info
        };

        let resultArray = [];

        try {
          const response = await axios.post(
            properties.aiqBaseUrl +
              properties.contractBaseUrl +
              properties.getAiSummary,
            {
              screenName: screenName.HIGH_COST_CLAIMS,
              eg_nid:
                employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
              incurredStartDate,
              incurredEndDate,
              paidStartDate,
              paidEndDate,
              apiData: cleanData,
            },
          );

          resultArray = response?.data?.data?.data?.result || [];
          setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
        } catch (apiError) {
          console.error('AI Summary API failed:', apiError);
          handleOpenSnackBar('Failed to load summary', 'warning', 4000);
          setAiSummaryData([]);
        }
      } catch (error) {
        console.error('Unexpected Error:', error);
        handleOpenSnackBar(
          'Something went wrong. Please try again.',
          'error',
          6000,
        );
        setAiSummaryData([]);
      } finally {
        setAiLoading(false);
      }
    };
    const apiCalls = async () => {
      setLoading(true);
      isPlanDatesFetched &&
        (await Promise.all([getClaimDistributionData()]).then(() => {
          setLoading(false);
        }));

      setLoading(false);
    };

    useEffect(() => {
      if (isInitializing) {
        return;
      }

      apiCalls();
      return () => {
        abortController.abort();
      };
    }, [
      isInitializing,
      isPlanDatesFetched,
      isIncurredDate,
      isPaidDate,
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      aggregationParameter,
      cohortDetailsStore.conditionsDetails,
    ]);

    useEffect(() => {
      memberIds.length > 0
        ? getRiskMembersList(memberIds)
        : (setRiskMemberListData([]),
          setSelectedColumns(defaultSelectedColumns));
    }, [pageNumber, sortField, sortOrder]);

    useEffect(() => {
      if (clickedMember) {
        memberSummaryStore.setPathDetails([
          [
            messages.BREADCRUMB.TEXT,
            messages.BREADCRUMB.SUMMARY,
            {
              color: patientAccessTheme.palette.primary[500],
              fontWeight: 500,
            },
            () => {
              navigate(HIGH_COST_CLAIMS);
            },
          ],
        ]);

        navigate(PATIENT_DETAILS, { state: { memberId: clickedMember } });
      }
    }, [clickedMember]);

    useEffect(() => {
      if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
        return;
      }
      const fetchPlanDates = async () => {
        if (!isPlanDatesFetched) {
          await getPlanDates();
        }
      };

      fetchPlanDates();
    }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

    const isPageLoading = isPlanDatesLoading || loading || isInitializing;

    return (
      <>
        {isPageLoading ? (
          loader
        ) : (
          <div>
            <Grid className={classes.root}>
              <Grid className={classes.container}>
                <PageTitleAndSubTitle
                  title={messages.TITLE}
                  subTitle={messages.SUB_TITLE}
                  showDownloadButton
                  // downloadButtonAction={() => setOpenReportsModal(true)}
                  downloadButtonAction={() => {
                    downloadPdf(
                      'highCostReport',
                      {
                        employer:
                          employerGroupStore?.employerGroupResponseData
                            ?.employer_group_name,
                        member_unique_id_list: [],
                        claim_id_list: [],
                        maxClaimDate:
                          employerGroupStore?.employerGroupResponseData
                            ?.max_claim_date,
                        ...payload,
                      },
                      handleOpenSnackBar,
                      'open',
                    );
                    handleOpenSnackBar(
                      snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                      'info',
                      6000,
                    );
                  }}
                  subTitleStyles={{
                    width: '700px',
                  }}
                  showAskAi={true}
                  askAiAction={handleAskAi}
                  showQueryDataButton={checkUserAccess(
                    UserAccessConstants.COHORT_DETAILS,
                    loginPageStore.userResponse.role.name,
                    loginPageStore.userFeatures,
                  )}
                  queryButtonText={
                    cohortDetailsStore.cohortDetailsList?.length > 0 &&
                    cohortDetailsStore.cohortDetailsList[0].category !== ''
                      ? 'Edit Cohort'
                      : 'Add Cohort'
                  }
                  queryDataAction={() => {
                    if (
                      checkUserAccess(
                        UserAccessConstants.COHORT_DETAILS,
                        loginPageStore.userResponse.role.name,
                        loginPageStore.userFeatures,
                      )
                    ) {
                      openModal();
                    }
                  }}
                />
                <div className={classes.titleContainer}>
                  <Typography
                    fontSize="17px"
                    lineHeight="21px"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                    fontType="semiBold"
                    margin="0px 8px"
                  >
                    {COMMON_TEXTS.FOR}
                  </Typography>
                  <DateFilter />
                </div>
                <TabSelection
                  selectedTabIndex={selectedTabIndex}
                  setSelectedTabIndex={handleSelectedIndex}
                  recommendationFetched={recommendationFetched}
                />
              </Grid>
              <Grid>
                <CohortFilterBar />
                {selectedTabIndex === 0 && (
                  <Grid className={classes.cardRoot}>
                    <Grid>
                      <CardComponent
                        title={messages.TITLE}
                        subTitle={''}
                        body={
                          <Grid className={classes.claimDistributionContainer}>
                            <VerticalBar
                              styles={{
                                zIndex: 2,
                                width: '80px',
                                height: '250px',
                                display: 'flex',
                                flexDirection: 'column',
                                borderRadius: '79px 79px 0 0',
                                overflow: 'hidden',
                              }}
                              color1Value={20}
                              color2Value={20}
                              color3Value={20}
                              displayValue1={claimantsDistData?.[0]?.[2]}
                              displayValue2={claimantsDistData?.[1]?.[2]}
                              displayValue3={claimantsDistData?.[2]?.[2]}
                              color1={
                                patientAccessTheme.palette
                                  .riskStratificationCard?.row2Color ??
                                '#FF8C8C'
                              }
                              color2={patientAccessTheme.palette.grey.A700}
                              color3={
                                patientAccessTheme.palette
                                  .riskStratificationCard?.row1Color
                              }
                            />
                            <BasicTable
                              columns={claimDistributionColumns}
                              rowsData={claimantsDistData}
                              displayType="row"
                              isFullTable={true}
                              width="100%"
                            />
                            <img
                              src={Line}
                              className={classes.line}
                              style={{ top: '35%' }}
                            />
                            <img
                              src={Line}
                              className={classes.line}
                              style={{ top: '55%' }}
                            />
                            <img
                              src={Line}
                              className={classes.line}
                              style={{ top: '70%' }}
                            />
                          </Grid>
                        }
                        height="370px"
                      />
                    </Grid>
                    <Grid>
                      <CustomColumnsTable
                        title={messages.TOP_10_CLAIMANTS}
                        subTitle={'View the members by Risk Categories'}
                        options={columnsDropdownOption}
                        mandateOptions={['Member ID']}
                        selectedItems={selectedColumns}
                        setSelectedItems={setSelectedColumns}
                        handleChangeColumns={handleChangeColumns}
                        handleExport={handleExportCSV}
                        columns={tableColumns}
                        rowsData={riskMemberListData}
                        tableLoading={tableLoading}
                        handleMemberClick={handleMemberClick}
                        handleSort={handleSort}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                        pageNumber={pageNumber}
                      />
                    </Grid>
                  </Grid>
                )}
                {selectedTabIndex === 1 && (
                  <RecommendationsTab
                    recommendationLoading={recommendationLoading}
                    isInternalPage={true}
                  />
                )}
              </Grid>
              <div id="scroll-top-element" />
            </Grid>
            {pageScrollDown('scroll-top-element')}
          </div>
        )}
        <Snackbar
          {...snackbarState}
          handleClose={handleCloseSnackBar}
          vertical="bottom"
          horizontal="right"
        />
        <AiSummaryCard
          open={activeAskAi}
          onClose={() => {
            setActiveAskAi(false);
            setAiSummaryData([]);
          }}
          aiSummaryData={aiSummaryData || []}
          loading={aiLoading}
        />
        <ReportsModal
          open={openReportsModal}
          setOpen={setOpenReportsModal}
          startDate={
            aggregationParameter === 'paid' ? paidStartDate : incurredStartDate
          }
          endDate={
            aggregationParameter === 'paid' ? paidEndDate : incurredEndDate
          }
        />
        <CohortDetailsModal
          open={open}
          handleClose={closeModal}
          totalResults={totalResults}
          isEditMode={isEditMode}
          existingMemberUniqueIds={memberIdList}
        />
      </>
    );
  },
);

export default HighCostClaimantsPage;
